import { Controller } from "@api/config";
import type { IRequestConfig } from "@api/config";

import type { TGetAllCategoriesUsers } from "./response.types";

class MessengerController extends Controller {
	public constructor() {
		super({ requestUrl: "models/messenger/" });
	}

	/**@GET ALL CATEGORIES USERS */
	public async getAllCategoriesUsersAsync({ token }: IRequestConfig) {
		return this.get<TGetAllCategoriesUsers[]>("base", "platformCategories/all", { token });
	}
}

export const messengerAPI = new MessengerController();
